import cn from 'classnames';
// Types
import { SportLandingFeature } from 'helpers/sportLandings';
// Helpers
import { buildImageFetchSrcSet, withImageFetchIfRemote } from 'helpers/cdn';
// Ui
import Button from 'ui3/Button/Button';
// Styles
import styles from '../SportLanding.module.scss';

type FeatureProps = {
  feature: SportLandingFeature;
  ctaLabel: string;
  onCtaClick: () => void;
  reversed?: boolean;
  children?: React.ReactNode;
};

const Feature = ({
  feature,
  ctaLabel,
  onCtaClick,
  reversed,
  children,
}: FeatureProps) => (
  <section className={styles.section}>
    <div className={cn(styles.feature, { [styles.featureReversed]: reversed })}>
      <div className={styles.featureContent}>
        <h2 className={styles.sectionTitle}>{feature.title}</h2>
        <p className={styles.sectionText}>{feature.text}</p>
        <Button variant="secondary" onClick={onCtaClick}>
          {ctaLabel}
        </Button>
      </div>
      <div className={styles.featureMedia}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={withImageFetchIfRemote(feature.image, 880)}
          srcSet={buildImageFetchSrcSet(feature.image, [440, 880])}
          sizes="(min-width: 1024px) 440px, 100vw"
          width={feature.imageWidth}
          height={feature.imageHeight}
          alt={feature.imageAlt}
          className={styles.featureImage}
          loading="lazy"
          decoding="async"
        />
        {children}
      </div>
    </div>
  </section>
);

export default Feature;
